export enum images_nutritional {
  banner_nutritional = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_nutritional.webp/beautify",
  banner_nutritional_mobile = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_nutritional_mobile.webp/beautify",
}
